import styled from "styled-components"

export default styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 3em;

`